<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click="$emit('closeModal')">
        <div class="row">
          <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
          <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
            <div class="modal-container" @click.stop>
              <div class="modal-header row" style="justify-content: flex-end">
                <div class="col">
                  <button
                    type="button"
                    class="close"
                    @click="$emit('closeModal')"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>

              <div class="modal-body">
                <h2 style="font-weight: normal;" class="title">
                  {{ isNew ? "New" : "Edit" }} {{ form_type }}
                </h2>
                <p class="sub--title">* is a required field</p>
                <form>
                  <div class="row">
                    <!-- <div class="col-sm-10"> -->

                    <template v-if="isNew">
                      <div class="col-md-4">
                        <div class="input-group">
                          <label class="label">
                            Username
                            <span style="color: red">*</span>
                          </label>
                        </div>
                      </div>
                      <div class="col-md-8">
                        <div class="input-group">
                          <input
                            v-model="form.username"
                            type="text"
                            class="input--style-4"
                            placeholder="Type Username"
                          />
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div class="col-md-4">
                        <div class="input-group">
                          <label class="label">
                            Username
                            <!-- <span style="color: red">*</span> -->
                          </label>
                        </div>
                      </div>
                      <div class="col-md-8">
                        <div class="input-group">
                          <input
                            v-model="form.username"
                            type="text"
                            class="input--style-4"
                            placeholder="Type Username"
                            disabled
                          />
                        </div>
                      </div>
                    </template>
                    <!-- </div> -->
                    <div class="col-md-4">
                      <div class="input-group">
                        <label class="label">
                          Type
                          <span style="color: red">*</span>
                        </label>
                      </div>
                    </div>
                    <div class="col-md-8">
                      <div class="input-group">
                        <MultiSelect
                          v-model="form.role"
                          :options="options.role"
                          :allow-empty="false"
                          placeholder="Choose Type"
                        ></MultiSelect>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="input-group">
                        <label class="label">
                          AHM Product
                          <span style="color: red">*</span>
                        </label>
                      </div>
                    </div>
                    <div class="col-md-8">
                      <div class="input-group">
                        <MultiSelect
                          v-model="form.product_category"
                          :options="options.product_category"
                          :multiple="true"
                          :allow-empty="false"
                          placeholder="Choose Product Type"
                        ></MultiSelect>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="input-group">
                        <label class="label">
                          Status
                          <span style="color: red">*</span>
                        </label>
                      </div>
                    </div>
                    <div class="col-md-8">
                      <div class="input-group">
                        <MultiSelect
                          v-model="form.status"
                          :options="options.status"
                          :allow-empty="false"
                          placeholder="Choose Status"
                          ></MultiSelect>
                          <!-- label="label"
                          track-by="value" -->
                      </div>
                    </div>
                    <template v-if="isNew">
                      <div class="col-md-4">
                        <div class="input-group">
                          <label class="label">
                            Password
                            <span style="color: red">*</span>
                          </label>
                        </div>
                      </div>
                      <div class="col-md-8">
                        <div class="input-group">
                          <input
                            v-model="form.password"
                            type="password"
                            class="input--style-4"
                            placeholder="Type Password"
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="input-group">
                          <label class="label">
                            Re-type Password
                            <span style="color: red">*</span>
                          </label>
                        </div>
                      </div>
                      <div class="col-md-8">
                        <div class="input-group">
                          <input
                            v-model="retype_password"
                            type="password"
                            class="input--style-4"
                            placeholder="Type Re-type Password"
                          />
                        </div>
                      </div>
                    </template>
                    <div
                      class="col-md-6"
                      v-if="config.is_company_exist"
                      :class="{ 'offset-md-3': isNew }"
                    >
                      <div class="input-group">
                        <label class="label">Company</label>
                        <MultiSelect
                          v-model="form.company"
                          :options="options.oilMaker.map((x) => x.code)"
                          :custom-label="
                            (opt) =>
                              options.oilMaker.find((x) => x.code == opt).title
                          "
                          placeholder="Choose Oil Maker"
                        ></MultiSelect>
                      </div>
                    </div>
                    <div
                      class="col-md-6"
                      v-if="!isNew"
                      :class="{ 'offset-md-3': !config.is_company_exist }"
                    >
                      <!-- <div class="input-group">
                        <label class="label"
                          >Status<span style="color: red">*</span></label
                        >
                        <MultiSelect
                          v-model="form.status"
                          :options="options.status"
                          :allow-empty="false"
                          placeholder="Choose Status"
                        ></MultiSelect>
                      </div> -->
                    </div>
                    <!-- <div class="col-md-4">
                      <div class="input-group">
                        <label class="label">Password</label>
                      </div>
                    </div> -->
                    <!-- <div class="col-md-8">
                      <div class="input-group">
                        <input class="input--style-4" type="password" name="password" v-model="form.password" placeholder="Type Password" />
                      </div>
                    </div> -->
                  </div>

                  <!-- Reset Password Start -->
                  <div class="row row-space outerBoxPass" v-if="!isNew">
                    <div class="col paddingInnerInnerBox whiteBg">
                      <div class="row" @click="collapsedPass = !collapsedPass">
                        <div class="col-6 left">
                          <p class="subPartTitle">Reset Password</p>
                        </div>
                        <div class="col-6 right">
                          <button
                            type="button"
                            class="btn btn-link collapseButton"
                            v-if="collapsedPass"
                          >
                            <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M5 5L10 0H0L5 5Z" fill="black"/>
                            </svg>
                          </button>
                          <button
                            type="button"
                            class="btn btn-link collapseButton"
                            v-else
                          >
                            <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M5 0L10 5H0L5 0Z" fill="black"/>
                            </svg>
                          </button>
                        </div>
                      </div>
                      <div v-if="!collapsedPass">
                        <!-- <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"> -->
                        <!-- <div class="col-md-1"> -->
                        <div class="d-flex">
                          <div class="input-group">
                            <label class="label">Password</label>
                            <!-- <input
                                  class="input--style-4"
                                  type="password"
                                  name="password"
                                  v-model="form.password"
                                  placeholder="Type Password"
                                /> -->
                          </div>
                          <!-- </div> -->
                          <!-- <div class="col-md-8"> -->
                          <div class="input-group col-md-8">
                            <!-- <label class="label">Password</label> -->
                            <input
                              class="input--style-4"
                              type="password"
                              name="password"
                              v-model="form.password"
                              placeholder="Type Password"
                            />
                          </div>
                        </div>
                        <!-- </div> -->
                        <!-- </div> -->
                        <div class="d-flex">
                          <div class="input-group">
                            <label class="label">Re-type Password</label>
                            <!-- <input
                              class="input--style-4"
                              type="password"
                              name="retype_password"
                              v-model="retype_password"
                              placeholder="Type Retype Password"
                            /> -->
                          </div>
                          <div class="input-group col-md-8">
                            <!-- <label class="label">Re-type Password</label> -->
                            <input
                              class="input--style-4"
                              type="password"
                              name="retype_password"
                              v-model="retype_password"
                              placeholder="Type Re-type Password"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Reset Password End -->

                  <div class="row">
                    <div class="col mt-5" style="text-align: end">
                      <button
                        type="button"
                        class="btn btn-outline-danger px-3"
                        style="font-size: 140%"
                        @click="$emit('closeModal')"
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary ml-3 px-4"
                        style="font-size: 150%"
                        @click="submitForm()"
                      >
                        {{ isNew ? "Add" : "Edit" }}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
      </div>
    </div>
  </transition>
</template>

<script>
import MultiSelect from "vue-multiselect";
import axios from "axios";

export default {
  data() {
    let user = this.$store.getters.currentUser;

    return {
      user: user,
      dataReady: false,
      mobile: this.isMobile(),
      isNew: true,
      config: {
        is_company_exist: false,
      },
      product_category_feed: null,
      options: {
        role: [],
        status: ['Active','Inactive'],
        product_category: [],
        oilMaker: this.$store.getters.getOilMaker,
      },
      form: {
        username: "",
        role: "",
        password: "",
        status: "",
        product_category: [],
      },
      retype_password: "",

      collapsedPass: true,
    };
  },
  props: [
    "data", //data used for edit mode
    "is_company_exist", //company exist in this form or not
    "api_new", //api url used for new
    "api_edit", //api url used for edit
    "form_type",
  ],
  components: {
    MultiSelect,
  },
  computed: {
    convertFormStatus() {
      const formStatus = this.form.status === "Inactive" ? 0 : 1;

      return formStatus;
    },
    convertFormProductCategory() {
      //   const productItems = this.form.product_category.split(", ");
      // const result = productItems.map((item) => ({ name: item }));

      //   this.value = result;

      const matchedItems = this.product_category_feed
        .filter((product) => this.form.product_category.includes(product.name))
        .map((product) => product.id);

      // this.value = [...matchedItems];

      //   const productsId = this.form.product_category.map(
      //     (product) => product.id
      //   );

      // console.log("match product category conversion:", matchedItems);

      return [...matchedItems];
    },
    // convertSelectedProductCategory() {
    //   const selectedProduct = this.product_category_feed.filter((product) =>
    //     this.data.product_category.split(",").includes(product.name)
    //   );
    //   console.log("Selected product:", selectedProduct);

    //   return selectedProduct;
    // },
  },
  async mounted() {
    // this.convertSelectedProductCategory();

    // Fetch feed data from API
    await this.fetchFeedData();

    this.config.is_company_exist = this.is_company_exist;

    if (this.data) await this.convertEdit();
  },
  watch: {
    "form.karesidenan"() {
      this.options.city = this.$store.getters.getCityBySingleId(
        this.form.karesidenan
      );
      this.form.city = "";
    },
  },
  methods: {
    async fetchFeedData() {
      try {
        const token = this.user.token;
        const headers = {
          Authorization: `Bearer ${token}`,
        };

        const endpoints = [
          "https://sahmoil-sso.ahm.to/api/admin/feeds/product-category",
          "https://sahmoil-sso.ahm.to/api/admin/feeds/roles", // cari env
        ];

        const resps = await Promise.all(
            endpoints.map((url) => this.$httpSSO.get(url, { headers }))
          // endpoints.map((url) => axios.get(url))
        );

        this.product_category_feed = resps[0].data.data;
        // console.log("product category feed:", this.product_category_feed);

        const productCategories = resps[0].data.data.map((prod) => prod.name);

        const roles = resps[1].data.data.map((role) => role.name);

        this.options.product_category = [...productCategories];
        // console.log("Product category options:", this.options.product_category);

        this.options.role = [...roles];
      } catch (error) {
        console.error("Error fetching product category feeds", error);
      }
    },
    convertEdit() {
      this.isNew = false;

      // console.log("log from convertEdit");
      // console.log("Edit data", this.data);

      //   this.form.id = this.data.id;
      this.form.role = this.data.roles;
      this.form.status = this.data.status;
      this.form.product_category = this.data.product_category.split(", ");
      // this.form.password = "";
      // this.form.product_category = this.convertSelectedProductCategory;

      // this.convertSelectedProductCategory;
      // console.log(
      //   "Parent data product category:",
      //   this.data.product_category.split(",")
      // );

      // console.log("Form data product category:", this.form.product_category);

      //Optional for some
      this.form.company = this.data.company;
    },
    notNullObject(obj) {
      let ret = {};
      for (var i in obj) if (obj[i] !== null && obj[i] !== "") ret[i] = obj[i];
      // console.log("from notNullObject method:", ret);

      return ret;
    },
    // async
    validateForm() {
      // let method = this.isNew ? "post" : "put";
      // let url = this.isNew ? this.api_new : this.api_edit + this.data.id;
      let errors = [];

      // Type
      if (!this.form.role)
        errors.push("<strong>Type</strong> is a required field!");

      // Status
      if (!this.form.status)
        errors.push("<strong>Status</strong> is a required field!");

      // Product Type
      if (this.form.product_category.length === 0)
        errors.push("<strong>Product type</strong> is a required field!");

      // COMPANY EXIST
      if (this.config.is_company_exist) {
        // Company
        if (!this.form.company)
          errors.push("<strong>Company</strong> is a required field!");
      }

      // NEW MODE
      if (this.isNew) {
        // Username
        if (!this.form.username)
          errors.push("<strong>Username</strong> is a required field!");

        // Password
        if (!this.form.password)
          errors.push("<strong>Password</strong> is a required field!");
        // Retype Password
        else if (!this.retype_password)
          errors.push("<strong>Retype Password</strong> is a required field!");
        // Password does not match with retype password
        else if (this.form.password !== this.retype_password)
          errors.push(
            "<strong>Password</strong> does not match with <strong>Retype Password</strong>!"
          );

        // "Password tidak valid. Pastikan terdiri dari huruf kecil, huruf besar, angka, simbol, dan lebih dari 10 karakter."
        // try {
        //   const response = await this.$httpSSO[method](url, {
        //     password: this.form.password,
        //   });
        // } catch (error) {}
      }

      // EDIT MODE
      else {
        // Status
        if (!this.form.status)
          errors.push("<strong>Status</strong> is a required field!");

        // Reset Password Not Empty
        if (this.form.password || this.retype_password) {
          // Password does not match with retype password
          if (this.form.password !== this.retype_password)
            errors.push(
              "<strong>Password</strong> does not match with <strong>Retype Password</strong>!"
            );
        }
      }

      if (errors.length > 0) {
        this.$swal.fire({
          title: "Error!",
          icon: "error",
          type: "error",
          html: errors.join("<br>"),
        });
        return false;
      } else return true;
    },
    async submitForm() {
      // console.log("form from user input:", this.form);
      let vm = this;

      // if (this.form.product_category) {
      //   this.options.product_category = this.form.product_category;
      // }

      const payload = {
        ...this.form,
        status: this.convertFormStatus,
        product_category: this.convertFormProductCategory,
      };
      // console.log("payload for submit:", payload);

      if (await vm.validateForm()) {
        let method = this.isNew ? "post" : "put";
        let url = this.isNew ? this.api_new : this.api_edit + this.data.id;

        let form = JSON.parse(JSON.stringify(this.form));
        // console.log("form json:", form);

        //Check if company exist or not, if not, delete it from the form
        if (!this.config.is_company_exist) delete form.company;

        //Check if isNew, delete status
        if (this.isNew) delete form.status;

        const token = this.user.token;
        const headers = {
          Authorization: `Bearer ${token}`,
        };

        // this.$http[method]
        // axios[method](url, await this.notNullObject(form))
        this.$httpSSO[method](url, await payload, { headers })
          .then((resp) => {
            // alert(`Partshop ${vm.form.name} has been created`);
            this.$swal.fire({
              title: `${this.isNew ? "User successfully created":"User successfully updated"}`,
              iconHtml:'<svg width="113" height="113" viewBox="0 0 113 113" fill="none" xmlns="http://www.w3.org/2000/svg"><g opacity="0.905615"><path d="M56.2012 1.70117C86.2797 1.70117 110.701 26.1226 110.701 56.2012C110.701 86.2797 86.2797 110.701 56.2012 110.701C26.1226 110.701 1.70117 86.2797 1.70117 56.2012C1.70117 26.1226 26.1226 1.70117 56.2012 1.70117Z" fill="#C7F1E0"/><path d="M56.2012 1.70117C86.2797 1.70117 110.701 26.1226 110.701 56.2012C110.701 86.2797 86.2797 110.701 56.2012 110.701C26.1226 110.701 1.70117 86.2797 1.70117 56.2012C1.70117 26.1226 26.1226 1.70117 56.2012 1.70117Z" stroke="white" stroke-width="3.40194"/></g><path d="M56.1995 8.30371C82.7243 8.30371 104.26 29.8398 104.26 56.3646C104.26 82.8894 82.7243 104.425 56.1995 104.425C29.6747 104.425 8.13867 82.8894 8.13867 56.3646C8.13867 29.8398 29.6747 8.30371 56.1995 8.30371Z" fill="#2CDA94"/><path d="M33.7988 58.3034L47.7826 72.0157L76.0218 42.8262" stroke="white" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/></svg>',
              text: `${
                this.isNew ? "The account is now ready to use!" : "Your data has been successfully updated!"
              }`,
              confirmButtonColor: "#1B698E",
              didOpen: () => {
                // Get the confirm button and add your class
                const confirmButton = document.querySelector('.swal2-confirm');
                if (confirmButton) {
                  confirmButton.style.flex = '1';
                  // confirmButton.classList.add('my-wide-button');
                  // OR apply styles directly:
                  // confirmButton.style.padding = '14px';
                }
              }
            });

            this.$emit("refreshData");
            this.$emit("closeModal");
          })
          .catch((err) => {
            console.log(err);
            // console.log(err.response.data.message);
            // if (Array.isArray(err.response.data.data.details)) {
            //   this.$swal.fire({
            //     title: "Error!",
            //     icon: "error",
            //     type: "error",
            //     html: err.response.data.data.details
            //       .map((x) => x.message)
            //       .join("<br>"),
            //   });
            // } else {
            // }
            this.$swal.fire({
              title: "Error!",
              icon: "error",
              type: "error",
              text: err.response.data.message,
            });
          });
      }
    },
  },
};
</script>

<style scoped>
/* .modal-container .multiselect__single {
  text-transform: capitalize;
}  */

label {
  font-weight: normal;
}

.btn {
  font-weight: normal;
}

.modal-mask {
  position: fixed;
  z-index: 1020;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 100%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
      * The following styles are auto-applied to elements with
      * transition="modal" when their visibility is toggled
      * by Vue.js.
      *
      * You can easily play with the modal transition by editing
      * these styles.
      */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

/* MODAL STARTS */
.modal-body {
  margin: 0;
}

.modal-body .moduleLine {
  margin-bottom: 0vh;
}

.modal-body .moduleLine a {
  text-decoration: none;
}

.modal-body .moduleLine .moduleBox:hover {
  background-color: #e0e0e0;
  transition: background-color 0.7s ease;
  color: #212121;
  transition: color 0.7s ease;
}

.modal-body .moduleLine .moduleBox {
  border: 1px solid #bdbdbd;
  border-radius: 20px;
  padding: 20px 0;
  color: black;
  margin-bottom: 3vh;
}

.modal-body .moduleLine .moduleBox i {
  font-size: 5vh;
}

h3.modalHeadline {
  margin: 0 0 20px 0;
  font-weight: bold;
  text-align: center;
}

/* MODAL ENDS */

/* ==========================================================================
    #FORM made by Colorlib (https://colorlib.com)
    ========================================================================== */
input {
  outline: none;
  margin: 0;
  border: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  width: 100%;
  font-size: 14px;
  font-family: inherit;
}

.input--style-4 {
  /* width: 300px; */
  line-height: 50px;
  background: #fafafa;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  padding: 0 20px;
  font-size: 16px;
  color: #666;
  -webkit-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #666;
}

.input--style-4:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #666;
  opacity: 1;
}

.input--style-4::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #666;
  opacity: 1;
}

.input--style-4:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #666;
}

.input--style-4:-ms-input-placeholder {
  /* Microsoft Edge */
  color: #666;
}

.label {
  width: 150px;
  text-align: left;
  font-size: 16px;
  color: #555;
  text-transform: capitalize;
  display: block;
  margin-bottom: 0;
}

.radio-container {
  display: inline-block;
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  font-size: 16px;
  color: #666;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
  background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
  display: block;
}

.radio-container .checkmark:after {
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background: #57b846;
}

.checkmark {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #e5e5e5;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.input-group {
  position: relative;
  /* margin-bottom: 22px; */
  padding: 20px;
  flex-wrap: nowrap;
  align-items: center;
}

.input-group-icon {
  position: relative;
}

.input-icon {
  position: absolute;
  font-size: 18px;
  color: #999;
  right: 18px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  cursor: pointer;
}

/* ==========================================================================
       #TITLE made by Colorlib (https://colorlib.com)
       ========================================================================== */
.title {
  font-size: 40px;
  color: #525252;
  /* margin-bottom: 40px; */
  text-align: center;
}

.sub--title {
  color: red;
  margin-bottom: 40px;
  text-align: center;
}

.center {
  text-align: center;
}
.left {
  text-align: left;
}
.right {
  text-align: right;
}

.outerBox {
  padding: 0 20px;
}
.innerBox {
  border: 1px solid #eeeeee;
  border-radius: 5px;
  background-color: white;
  padding: 5vw;
  box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.15);
}
.paddingInnerInnerBox {
  padding: 10px 15px;
}
.outerBoxPass {
  padding: 0;
}
.innerBoxPass {
  border: 1px solid #bdbdbd;
  border-radius: 5px;
  box-shadow: 10px 10px 20px #e0e0e0;
}
.innerBoxPass > .row:first-child {
  cursor: pointer;
}
.paddingInnerInnerBox p {
  margin: 0;
}
.subPartTitle {
  font-size: 110%;
  padding: 6px 12px;
  color: #757575;
}
.collapsed:hover {
  text-decoration: underline;
}
.collapseButton {
  color: black;
}

.input--style-4:disabled {
  background: #cfcfcf;
}

.modal-body {
  max-height: 80vh;
  overflow-y: auto;
  overflow-x: auto;
}

.innerBox {
  padding: 0.8em 1.5em;
  border: 1px solid #eeeeee;
  border-radius: 5px;
  background-color: white;
  box-shadow: 2px 2px 5px #e0e0e0;
}

.hoverable:hover {
  cursor: pointer;
}
</style>
